export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 140,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('form_label_tripReimbursementNo') || '出差费用报销单号',
    field: 'tripReimbursementNo',
    width: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '有效状态',
    field: 'tripReimbursementStatus',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('form_label_salesPersonName') || '申请人',
    field: 'salesPersonName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_expensePayerName') || '申请人公司',
    field: 'expensePayerName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_requestDate') || '申请日期',
    field: 'requestDate',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_currencyAmount') || '原币总金额',
    field: 'currencyAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    slots: {
      default: 'currencyAmount',
    },
  },
  {
    title: that.$l('form_label_purposeOfTrip') || '详细说明',
    field: 'purposeOfTrip',
    minWidth: 500,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
]
